<ng-container *ngIf="(configs | async) != null">
  <div *ngIf="(currentConfig | async) == null">
    <div class="row">
      <div class="col-12">
        <p class="fw-bold">
          Update / delete existing GL files or add a new GL export to handle your reporting needs.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-connectpay settings-table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Type</th>
              <th>Export To</th>
              <th>Frequency</th>
              <th>Approval</th>
              <th>Last Updated By</th>
              <th class="text-center">Duplicate</th>
              <th class="text-center">Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let config of configs | async">
              <td>
                <a (click)="updateConfig(config)">{{ config.Name }}</a>
              </td>
              <td>
                <span *ngIf="config.Type == GeneralLedgerDownloadTypes.Checks">Checks</span>
                <span *ngIf="config.Type == GeneralLedgerDownloadTypes.Totals">Totals</span>
              </td>
              <td>
                <span *ngIf="config.ExportFileType == GeneralLedgerExportTypes.IIF"
                  >Quickbooks Desktop</span
                >
                <span *ngIf="config.ExportFileType == GeneralLedgerExportTypes.QBO"
                  >Quickbooks Online</span
                >
                <span *ngIf="config.ExportFileType == GeneralLedgerExportTypes.CSV">CSV</span>
              </td>
              <td>
                <span *ngIf="config.TimeFrame == GeneralLedgerExportFrequencies.DateRange"
                  >Custom</span
                >
                <span *ngIf="config.TimeFrame == GeneralLedgerExportFrequencies.MTD">Monthly</span>
                <span *ngIf="config.TimeFrame == GeneralLedgerExportFrequencies.YTD">Annually</span>
                <span *ngIf="config.TimeFrame == GeneralLedgerExportFrequencies.QTD"
                  >Quarterly</span
                >
                <span *ngIf="config.TimeFrame == GeneralLedgerExportFrequencies.Payroll"
                  >Current Payroll</span
                >
              </td>
              <td>
                <span *ngIf="config.SubmissionType == ApprovalTypes.Automatic"
                  >Automatic Export</span
                >
                <span *ngIf="config.SubmissionType == ApprovalTypes.Approval"
                  >Requires Approval</span
                >
                <span *ngIf="config.SubmissionType == ApprovalTypes.Manual">Manual Export</span>
              </td>
              <td>
                {{ config.Username }}
              </td>
              <td class="text-center">
                <button class="btn btn-link text-cp-green" (click)="duplicate(config)">
                  <i class="far fa-copy fa-xl"></i>
                </button>
              </td>
              <td class="text-center">
                <button class="btn btn-link text-danger" (click)="delete(config)">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary" (click)="addNew()">+ Add New GL Export</button>
      </div>
    </div>
  </div>
  <!-- Update -->
  <div *ngIf="(currentConfig | async) != null && !editMapping">
    <lib-export-files-primary
      #exportFilesPrimary
      (showSettings)="showSettings()"
      (editMappings)="showEditMapping($event)"
      [inUpdateViewState]="true"></lib-export-files-primary>
  </div>
  <lib-gl-mapping
    *ngIf="editMapping && (currentConfig | async).Type == GeneralLedgerDownloadTypes.Totals"
    (cancelClicked)="showSettings()"
    [config]="currentConfig | async"></lib-gl-mapping>
  <lib-gl-checks-mapping
    *ngIf="editMapping && (currentConfig | async).Type == GeneralLedgerDownloadTypes.Checks"
    (finished)="showSettings()"
    [config]="currentConfig | async"></lib-gl-checks-mapping>
</ng-container>
